import React, { useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { CredsContext } from "./Contexts";
import Tools from "./JNSTools";
import {
  ChatUIComponent,
  MessagesDirective,
  MessageDirective,
} from "@syncfusion/ej2-react-interactive-chat";
import useCurrentColorScheme from "@mui/system/cssVars/useCurrentColorScheme";

function ProjectDiscussion(props) {
  const creds = useContext(CredsContext).creds;
  const projectObject = JSON.parse(sessionStorage.getItem("projectObject"));
  const [messages, setMessages] = useState(null);

  const users = JSON.parse(localStorage.getItem(creds.company + "|User"));
  const userModels = users.map((userRec) => ({
    id: parseInt(userRec.id),
    user: userRec.name,
    cssClass: "custom-container",
  }));

  const currentUserModel = userModels.find((elem) => elem.id == creds.id);
  //const currentUserModel = userModels.find((elem) => elem.id == 21);
  const instanceUrl = Tools.getInstanceUrl(creds);
  const restMessagesUrl = instanceUrl.replace(
    "api.pl",
    "rest/v1/projects/" + projectObject.id + "/threaded-messages",
  );

  useEffect(() => {
    props.waitHandler(true);
    Tools.refreshSPPToken(creds).then((accessToken) => {
      Tools.fetchGet(restMessagesUrl, "Bearer " + accessToken).then(
        (response) => {
          console.log(response); // array of objects -- data[]

          setMessages(response.data);
          props.waitHandler(false);
        },
      );
    });
  }, []);

  const messageSend = (event) => {
    const inst = JSON.parse(
      Tools.decrypt(localStorage.getItem("instanceInfo")),
    );

    // text, author
    const messageOptions = {
      //userId: currentUserModel.id,
      content:
        inst.userType == "generic"
          ? "[by: " +
            event.message.author.properties.user +
            "] " +
            event.message.text
          : event.message.text,
      //tableName: "project",
      //recordId: projectObject.id,
    };

    Tools.fetchPostRest(restMessagesUrl, creds, messageOptions).then(
      (response) => {
        console.log(response); // data, message -- data[0].id
      },
    );
  };

  const messageTemplate = (context) => {
    return (
      <div className="message-items e-card">
        <div className="message-text">{context.message.text}</div>
      </div>
    );
  };

  const messageToolbarSettings = {
    items: [],
  };
  return (
    <div style={{ width: "800px" }}>
      <ChatUIComponent
        //delayUpdate={true}
        id="messageTemplate"
        //cssClass="custom-container"
        messageToolbarSettings={messageToolbarSettings}
        showTimeBreak={true}
        //messageTemplate={messageTemplate}
        user={currentUserModel}
        headerText={projectObject.customer_name + " : " + projectObject.name}
        timeStampFormat="MMMM dd, yyyy &nbsp;&nbsp;&nbsp; hh:mm a"
        messageSend={messageSend}
      >
        <MessagesDirective>
          {messages
            ? messages.map((dataElem) => (
                <MessageDirective
                  key={dataElem.id}
                  author={userModels.find(
                    (elem) => parseInt(elem.id) == parseInt(dataElem.userId),
                  )}
                  text={dataElem.content}
                  timeStamp={new Date(dataElem.created.substring(0, 10))}
                ></MessageDirective>
              ))
            : null}
        </MessagesDirective>
      </ChatUIComponent>
    </div>
  );
}

export default ProjectDiscussion;

ProjectDiscussion.propTypes = {
  waitHandler: PropTypes.func,
};
